import axiosConfig from "./axiosConfig";

export interface ContactEmail {
  email: string;
  name: string | null;
  title: string | null;
  // Subset of {"gmail","hubspot","apollo"} - the source(s) the address
  // was found in (merged when the same address comes from several).
  sources: string[];
  confidence: number;
}

export interface LeadContactEmailsResponse {
  tenant: ContactEmail[];
  landlord: ContactEmail[];
}

const getLeadContactEmails = async (
  authToken: string,
  leadId: string
): Promise<LeadContactEmailsResponse> => {
  const { data } = await axiosConfig.get(`/leads/${leadId}/contact-emails`, {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return data;
};

export default getLeadContactEmails;
